import styled from 'styled-components'

const animation = { // TODO: get from Form Styles
  duration: '200ms'
}

export const Container = styled.div<any>`
  position: relative;
  cursor: pointer;
  user-select: none;
  display: block;
  border-color: ${props => props.theme.form.passiveColor};
  border: 1px solid ${props => props.isSelected ? props.theme.palette.primary.alpha : props.theme.form.passiveColor};
  border-radius: ${props => props.theme.form.borderRadius};
  padding: 20px 25px 20px 45px;
  transition: box-shadow ${animation.duration} linear;

  &:hover,
  &:focus {
    box-shadow: ${props => props.theme.form.boxShadow};
  }

  input {
    position: absolute;
    pointer-events: none;
    top: 22px;
    left: 18px;
  }
`
